module.exports = __webpack_public_path__ + "static/Affiches-BRIDGE-72ppp-4-380-625255ee744da8e429b332b67312acf2.png";